import React, { useEffect, useState } from "react";
import { ethers } from "ethers";
import MyManagersTable from "./MyManagersTable";
import { CTMTContract, cpCTMTConAdd, tmCTMTContract, cpCTMTContract } from "./ConAddsAndABIs"

function ChooseManager(){

    const [walletAddress, setWalletAddress] = useState("");
    const [balance, setBalance] = useState("");
    const [forceDissolutionTime, setForceDissolutionTime] = useState("");
    const [managerId, setManagerId] = useState("");   
    const [myManagerAddress, setMyManagerAddress] = useState("");     
    const [toSellectManagerId, setToSellectManagerId] = useState("");
    const [forceDissolveButton, setForceDissolveButton] = useState("");

    const [managersDataTable, setManagersDataTable] = useState([]);
    const [isWithManager, setIsWithManager] = useState([]);

    const [managersId, setManagersId] = useState([]);
    const [dissolutionStatus, setDissolutionStatus] = useState([]);
    const [managersAdd, setManagersAdd] = useState([]);
    const [managersTFT, setManagersTFT] = useState([]);
    const [managersTFTName, setManagersTFTName] = useState([]);
    const [managersAge, setManagersAge] = useState([]);
    const [managersCTMTDeps, setManagersCTMTDeps] = useState([]);
    const [managersGrowth, setManagersGrowth] = useState([]);
    const [managersBaseCTMT, setManagersBaseCTMT] = useState([]);
    const [managersTotalAssetValueInBUSDV, setManagersTotalAssetValueInBUSDV] = useState([]);
    const [managersCTMTReturned, setmanagersCTMTReturned] = useState([]);
    const [managersLi, setManagersLi] = useState([]);
    const [managersLr, setManagersLr] = useState([]);
    const [managersGr, setManagersGr] = useState([]);
    const [managersBUSDBal, setManagersBUSDBal] = useState([]);
    const [managersTFTB, setManagersTFTB] = useState([]);
    const [managersLastT, setManagersLastT] = useState([]);

    const [unrealizedSL, setUnrealizedSL] = useState([]);
    const [rateOfReturn, setRateOfReturn] = useState([]);
    const [liCoverageRatio, setLiCoverageRatio] = useState([]);
    const [lrCoverageRatio, setLrCoverageRatio] = useState([]);

    const [joinButton, setJoinButton] = useState([]);

    let currentData = [];

    let managerData = managersId.map((id, index) => {
      const managerObject = {};
      managerObject.id = id;
      managerObject.add = managersAdd[index]
      managerObject.dis = dissolutionStatus[index]
      managerObject.tft = managersTFT[index]
      managerObject.tftn = managersTFTName[index]
      managerObject.ma = managersAge[index]
      managerObject.ctmt = managersCTMTDeps[index]
      managerObject.bctmt = managersBaseCTMT[index]
      managerObject.busdv = managersTotalAssetValueInBUSDV[index]

      managerObject.grwt = managersGrowth[index]
      managerObject.rctmt = managersCTMTReturned[index]
      managerObject.li = managersLi[index]
      managerObject.lr = managersLr[index]
      managerObject.gr = managersGr[index]
      managerObject.busd = managersBUSDBal[index]
      managerObject.tftb = managersTFTB[index]
      managerObject.ltd = managersLastT[index]

      managerObject.usl = unrealizedSL[index]
      managerObject.ror = rateOfReturn[index]
      managerObject.licr = liCoverageRatio[index]
      managerObject.lrcr = lrCoverageRatio[index]

      managerObject.jb = joinButton[index]

      return managerObject;
    })

    let filteredManager = managerData.filter((manager) => manager.dis === 'false' )
    let sortedManager = filteredManager.sort((a, b) => a.bctmt > b.bctmt ? 1: -1);
    currentData = sortedManager

const column = [
  {heading: 'Id', value: 'id'},
  {heading: 'Join', value: 'jb'},
  //{heading: 'Dissolution', value: 'dis'},
  //{heading: 'Address', value: 'add'},
  {heading: 'Token For Trade', value: 'tftn'},
  {heading: 'Age in Days', value: 'ma'},
  //{heading: 'CTMT Deposits', value: 'ctmt'},
  //{heading: 'Growth', value: 'grwt'},
  {heading: 'Base BUSD', value: 'bctmt'},
  //{heading: 'BUSD Value', value: 'busdv'},
  {heading: 'CWJC Returned', value: 'rctmt'},
  //{heading: 'Local Insurance', value: 'li'},
  //{heading: 'Local Reserve', value: 'lr'},
  //{heading: 'Global Reserve', value: 'gr'},
  //{heading: 'TFT', value: 'tft'},
  
  //{heading: 'TFT Balance', value: 'tftb'},
  //{heading: 'BUSD Balance', value: 'busd'},
  //{heading: 'Force Dissolution', value: 'ltd'},
  {heading: 'Unrealized Profit or (Loss)', value: 'usl'},
  {heading: 'CWJC Return Rate', value: 'ror'},
  {heading: 'Local Insurance Coverage Rate', value: 'licr'},
  {heading: 'Global Reserve Coverage Rate', value: 'lrcr'}  
]    

    useEffect(() => {  
        
      const getWalletAddress = async () => {
        const accounts = await window.ethereum.request({
            method: "eth_requestAccounts",
        });
        setWalletAddress(accounts[0]);
      }
      
        getWalletAddress()
            .catch(console.error)

        const getIsWithManager = async () => {
          const accounts = await window.ethereum.request({method: "eth_requestAccounts",});
          const data = await cpCTMTContract.withManager(accounts[0])
          const dataF = data.toString()
          setIsWithManager(dataF);
        }
        
        getIsWithManager()
              .catch(console.error)

              const getForceDissolutionTime = async () => {
                const fdTime = await tmCTMTContract.forcedDissolveDate(managerId)
                const dStat = await tmCTMTContract.isDissolved(managerId)
                const fdTimeF1 = new Date(fdTime * 1000)
                const timeNow = new Date()
                const fdTimeF2 = fdTimeF1.toString()
                  setForceDissolutionTime(fdTimeF2)
                
                if (timeNow >= fdTimeF1 && dStat === false) {
                  setForceDissolveButton(<button onClick={handleForceDissolve} className="btn btn-success">Force Dissolve</button>)
                }

                }
          
                  
                  getForceDissolutionTime()
                  .catch(console.error)        
                  
                  const getManagerId = async () => {
                    const data = await tmCTMTContract.managerId(myManagerAddress)
                    const dataF = data.toString()
                      setManagerId(dataF)
                  }
        
                getManagerId()
                  .catch(console.error)                     

                  const getMyManagerAddress = async () => {
                    const data = await cpCTMTContract.providersManager(walletAddress)
                    const str = data.toString()
                    setMyManagerAddress(str)
                    }
            
                getMyManagerAddress()
                    .catch(console.error)                    

      const getMyGlobalReserve = async () => {
        
        const personCount = await tmCTMTContract.managersTradingCount()
        const now = new Date;
        const numNow = parseInt(now) / 1000
        let manId = [];
        let manDis = [];
        let manAdd = [];
        let manTFT = [];
        let manTFTName = [];
        let manAge = [];
        let manCTMTD = [];
        let manBctmt = [];
        let manTBusdV = [];
        let manCTMTr = [];
        let manGwt = [];
        let manLi = [];
        let manLr = [];
        let manGr = [];
        let manBUSD = [];
        let manTFTB = [];

        let manLtd = [];

        let manUsl = [];
        let manRor = [];
        let manLicr = [];
        let manLrcr = [];
        let manJoinB = [];
            
            
          async function handlePeopleData() {
            for (let i=0; i < personCount; i++) {
              const dis = await tmCTMTContract.isDissolved(i)
                const disF = dis.toString()
              const add = await tmCTMTContract.managerIdOwner(i)
              const tft = await tmCTMTContract.manTFT(i)
              const tftName = await tmCTMTContract.manTFTName(i)
              let bUsd = await tmCTMTContract.manBUSDBal(i) / (10**18)
                const busdP = bUsd.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})

              let ctmtDep = await tmCTMTContract.ctmtDeposits(i) / (10**18)
                const ctmtDepP = ctmtDep.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})

              let gwt = await tmCTMTContract.CTMTGrowthBal(i) / (10**18)
                const gwtP = gwt.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})

              const baseCtmt = (ctmtDep + gwt)
                const baseCtmtP = baseCtmt.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})

              const rtnd = await tmCTMTContract.accumRetByMan(i) / (10**18)
                const rtndP = rtnd.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})

              const lInsurance = await tmCTMTContract.liCTMTBal(i) / (10**18)
                const lInsuranceP = lInsurance.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})

              const lReserve = await tmCTMTContract.lrCTMTBal(i) / (10**18)
                const lReserveP = lReserve.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})

              const gReserve = await tmCTMTContract.checkGlobalReserve(i) / (10**18)
                const gReserveP = gReserve.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})

              let tftB = await tmCTMTContract.manTFTBal(i) / (10**18)
                const tftBP = tftB.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})    

              const fdDate = await tmCTMTContract.forcedDissolveDate(i)
              const fdDateF = parseInt(fdDate)
              const dateNow = Date.now() / 1000
              
              const dRem = (fdDateF - dateNow) / (60 * 60 * 24)
                const dRemP = dRem.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})

              const joinManager = async (e) => {
                e.preventDefault();
                const txn = await cpCTMTContract.chooseManager(add)
                await txn.wait();
                }                  
              
              const buttonO = <button onClick={joinManager}>Join</button>

                if (tftB === 0) {
                  const tftV = 0
                  const tav = (tftV + bUsd)
                  const usl = tav - ctmtDep - gwt
                  const tavF = tav.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) 
                  const uslF = usl.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) 
                    manTBusdV.push(tavF)
                    manUsl.push(uslF)

                } else {
                  const tftV = await tmCTMTContract.checkBusdValueofTFTBal(i) / (10**18)
                  const tav = (tftV + bUsd)
                  const usl = tav - ctmtDep - gwt
                  const tavF = tav.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) 
                  const uslF = usl.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})            
                    manTBusdV.push(tavF)
                    manUsl.push(uslF)
                }

              const rReturn =  (rtnd / ctmtDep) * 100
                const rReturnP = rReturn.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'   
              
              const liCoverage = (lInsurance / baseCtmt) * 100
                const liCoverageP = liCoverage.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'

              const lrCoverage = (lReserve / baseCtmt) * 100
                const lrCoverageP = lrCoverage.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'

                const start = await tmCTMTContract.manStartDate(i)
                const timeNow = new Date() / 1000
                const lapsed = (timeNow - start) / (24 * 60 * 60)
                const lapsedF = lapsed.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})

              manId.push(i) 
              manDis.push(disF)
              manAdd.push(add) 
              manTFT.push(tft) 
              manTFTName.push(tftName)
              manAge.push(lapsedF)
              manCTMTD.push(ctmtDepP)
              manBctmt.push(baseCtmtP)
              manGwt.push(gwtP)
              manCTMTr.push(rtndP)
              manLi.push(lInsuranceP)
              manLr.push(lReserveP)
              manGr.push(gReserveP)
              manBUSD.push(busdP) 
              manTFTB.push(tftBP)
              manLtd.push(dRemP)

              manRor.push(rReturnP)
              manLicr.push(liCoverageP)
              manLrcr.push(lrCoverageP)

              manJoinB.push(buttonO)

            }
            setManagersId(manId)
            setDissolutionStatus(manDis)
            setManagersAdd(manAdd)
            setManagersTFT(manTFT)
            setManagersTFTName(manTFTName)
            setManagersAge(manAge)
            setManagersCTMTDeps(manCTMTD)
            setManagersGrowth(manGwt)
            setManagersBaseCTMT(manBctmt)
            setManagersTotalAssetValueInBUSDV(manTBusdV)
            setmanagersCTMTReturned(manCTMTr)
            setManagersLi(manLi)
            setManagersLr(manLr)
            setManagersGr(manGr)
            setManagersBUSDBal(manBUSD)
            setManagersTFTB(manTFTB)
            setManagersLastT(manLtd)

            setUnrealizedSL(manUsl)
            setRateOfReturn(manRor)
            setLiCoverageRatio(manLicr)
            setLrCoverageRatio(manLrcr)

            setJoinButton(manJoinB)
          }

            handlePeopleData();
              return(null);
      }

        getMyGlobalReserve()
            .catch(console.error)  
    })    

      const handleForceDissolve = async (e) => {
        e.preventDefault();
        const txn = await tmCTMTContract.forceDissolve(managerId)
        await txn.wait();
    }       

    const handleChooseManagerValue = (e) => {
      setToSellectManagerId(e.target.value);
    }    
    
    const handleChooseManager = async (e) => {
        e.preventDefault();
        console.log(toSellectManagerId)
        const manAdd = await tmCTMTContract.managerIdOwner(toSellectManagerId)    
        const txn = await cpCTMTContract.chooseManager(manAdd)
        await txn.wait();
            setToSellectManagerId(0);
      }

   if (isWithManager === 'true') {
    return (
    <div>  
        <MyManagersTable /><br></br>   
        <p style={{"textAlign": "center"}}>{forceDissolveButton}</p>
        <p style={{"textAlign": "center", "fontSize": "12px"}}><b>Force Dissolution Available On:</b> {forceDissolutionTime}</p>                           
                          
    </div>)
   } else
   
{    return(
          <div>
              <div>
                      <h3 style={{"textAlign": "center"}}>Crypto Trading Managers</h3>
                  <form style={{"textAlign": "center"}} onSubmit={handleChooseManager}>
                          <input style={{"width": "75px"}} type="number" className="form-control" placeholder="0" onChange={handleChooseManagerValue} value={toSellectManagerId} /> <button style={{"width": "200px"}} type={"submit"} className="btn btn-success">Manually Sellect Manager</button>
                  </form><br/> 

                  <table className="manTable" >
                    <colgroup>
                      <col className='col1' />
                      <col className='col2' />
                      <col className='col3' span='11'/>
                      <col className='col4' span='3'/>

                    </colgroup>
                    <thead>
                      <tr>
                          
                      </tr>
                        <tr>
                            {column.map((item, index) => <th key={index} >{item.heading}</th>) }
                        </tr>
                    </thead>
                    <tbody>
                            {currentData.map((item, index) => (
                                  <tr key={index}>
                                    {column.map((columnItem, index) => {
                                      return<td key={index} >{item[`${columnItem.value}`]} </td>
                                    })}
                                  </tr>
                                )) }
                    </tbody>
                  </table>
              </div> 
            </div>    
          ) }
}

export default ChooseManager;